import { useState, useEffect } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function DiscographyPage() {
  const [albums, setAlbums] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAlbums();
  }, []);

  const fetchAlbums = async () => {
    try {
      const res = await fetch(`${API}/albums`);
      if (res.ok) {
        setAlbums(await res.json());
      }
    } catch (e) {
      console.error("Error fetching albums:", e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-wrapper" data-testid="discography-page">
      <div className="myspace-container">
        {/* Header */}
        <div className="myspace-header">
          <h3>kezzio's discography</h3>
        </div>

        <div className="myspace-section m-2">
          <div className="myspace-section-title">:: All My Released Music ::</div>
          <div className="myspace-section-content">
            <p className="text-[11px] text-[var(--text-white)] opacity-80 mb-4">
              All of my current released music! Click an album to listen on Bandcamp.
            </p>

            {loading ? (
              <div className="text-center text-[var(--text-white)] opacity-80 text-[11px] py-4">
                Loading albums...
              </div>
            ) : albums.length > 0 ? (
              <div className="album-grid-2006">
                {albums.map((album, index) => (
                  <a
                    key={album.id}
                    href={album.bandcamp_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block text-center no-underline group"
                    data-testid={`discography-album-${index}`}
                  >
                    <img
                      src={album.cover_url}
                      alt={album.title}
                      className="album-thumb-2006 w-full aspect-square object-cover group-hover:border-[#00ccff]"
                    />
                    <div className="text-[11px] text-[var(--accent-orange)] mt-2 font-bold">
                      {album.title}
                    </div>
                    <div className="text-[10px] text-[var(--text-white)] opacity-70">
                      {album.release_date}
                    </div>
                  </a>
                ))}
              </div>
            ) : (
              <div className="text-center text-[var(--text-white)] opacity-80 text-[11px] py-4">
                No albums yet. Check back soon!
              </div>
            )}
          </div>
        </div>

        {/* Footer */}
        <div className="text-center text-[10px] text-[var(--text-white)] opacity-50 py-3 border-t border-[var(--border-color)]">
          <a href="/" className="text-[var(--text-link)]">&laquo; Back to Home</a>
        </div>
      </div>
    </div>
  );
}
